__turbopack_context__.v({
  "events": "Events-module-scss-module__58UwcG__events",
  "events_expand_button": "Events-module-scss-module__58UwcG__events_expand_button",
  "events_title": "Events-module-scss-module__58UwcG__events_title",
  "events_wrapper": "Events-module-scss-module__58UwcG__events_wrapper",
});
